import React from 'react';
import PostCard from './PostCard';
import { PostCardsList } from './styles/RecommendedPosts.styles';
import { useLanguage } from '../../locales';
const RelevantPosts = ({ posts, className }) => {
  const { translation } = useLanguage();
  if (!posts || !posts.length) return null;
  return (
    <section>
      <h2>{translation.posts.relevantPosts}</h2>
      <PostCardsList className="relevant-posts">
        {posts.map((post) => (
          <PostCard key={post.contentful_id} post={post} />
        ))}
      </PostCardsList>
    </section>
  );
};

export default RelevantPosts;
